/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import injectCss from "@insite/mobius/utilities/injectCss";
import styled, { css } from "styled-components";

export const styledBox = css`
    box-sizing: border-box;
    padding: 20px;
    margin-bottom: 20px;
    background: ${getColor("text.inverse")};
    border: 1px solid ${getColor("common.ui12")};
    border-radius: 6px;
`;

const StyledBox = styled.div<InjectableCss>`
    ${styledBox}
    ${injectCss}
`;

export default StyledBox;
